import React, { useState, useEffect } from "react";
import CustomTable from "../../../../../customComponents/CustomTable";
import searchIcon from "./../../../../../../Assets/icons/searchicon.svg";
import editIcon from "./../../../../../../Assets/icons/Un-Checkbox.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import SearchInput from "../../../../../customComponents/CustomSearch/SearchInput";
import Loader from "../../../../../customComponents/CustomLoader";

const DepartmentList = () => {
  const [departments, setDepartments] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [city, setCity] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [loading, setLoading] = useState(true);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDepartments(newPage);
  };

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.get("/pincodestatecity/cityList", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response?.data?.data; 
      const cityOptions = data?.map((city) => ({
        value: city.city_id,
        label: city.city_name,
      }));
      setCity(cityOptions); 
    } catch (error) {
      console.log(error);
    }
  };
  const fetchDepartments = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        "department/list",
        {
          orderBy: "department_id desc",
          page,
          pageSize,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalRevenue = response?.data?.data?.total_revenue;
      const unitSold = response?.data?.data?.unit_sold;
      const revenueCount = response?.data?.data?.annual_revenue;

      setTotalData(totalCount);
      setTotalActive(totalRevenue);
      setTotalInactive(unitSold);
      setRevenue(revenueCount);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setDepartments(formattedData);
      console.log("response", response);
      // toastSuccess("Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching department list:", error);
    }
    finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchDepartments();
    fetchCity();
  }, []);

  // Table headers
  const DEPARTMENT_TABLE_HEADERS = [
    // "Sr No.",
    // "Department ID",
    "Department",
    "Description",
    "Status",
    "Action",
  ];

  // Key mapping for CustomTable component
  const DEPARTMENT_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Department ID": "department_id",
    Department: "department_name",
    Description: "department_desc",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITDEPARTMENT}`, {
      state: { data: rowData },
    });
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchDepartments();
    }
  }, [searchTerm]);
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
    <div>
      <div className="OnboardManagamentContainer row">
        <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
          <h5>Department Management</h5>
        </div>
        <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
          <div
            className="topleftdataContainer"
            style={{ borderRight: "1px solid lightgrey" }}
          >
            <h5 className="listTopDataValueText">{totalData} </h5>
            <h6>All Departments</h6>
          </div>
          <div
            className="topleftdataContainer"
            style={{ borderRight: "1px solid lightgrey" }}
          >
            <h5 className="listTopDataValueText">{totalInactive} </h5>
            <h6>Unit Sold</h6>
          </div>
          <div
            className="topleftdataContainer"
            style={{ borderRight: "1px solid lightgrey" }}
          >
            <h5 className="listTopDataValueText">{totalActive} </h5>
            <h6>Revenue</h6>
          </div>
          <div className="topleftdataContainer">
            <h5 className="listTopDataValueText">{revenue} </h5>
            <h6>Annual Revenue</h6>
          </div>
          <div>
            <button
              className="addcustomerbutton"
              onClick={() =>
                navigate("/admin/manage-dealer/department/add-department")
              }
            >
              Add Department
            </button>
          </div>
        </div>
      </div>

      <div className="tableWrapper">
        <div className="admin-list-container">
          <div className="listsearchContainer">
            <h5>Departments List</h5>
            <div>
              <SearchInput
                placeholder="Search Departments"
                onSearch={fetchDepartments}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
        </div>

        <CustomTable
          data={departments}
          headers={DEPARTMENT_TABLE_HEADERS}
          keyMapping={DEPARTMENT_KEY_MAPPING}
          itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={handleEdit}
          totalRecords={totalRecords}
        />
      </div>
    </div>
     )}
  </div>
  );
};

export default DepartmentList;
